import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("b", null, "Email: ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("b", null, "Balance: ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("b", null, "Basecost: ", -1)
const _hoisted_4 = { class: "font-bold text-primary" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("b", null, "Supporter: ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("b", null, "Id: ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_col = _resolveComponent("el-col")!
  const _directive_loading = _resolveDirective("loading")!

  return (_ctx.sellerTeam)
    ? (_openBlock(), _createBlock(_component_el_row, {
        key: 0,
        class: "w-full"
      }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, { class: "text-base font-bold" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.sellerTeam.name), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, { class: "mt-3" }, {
                default: _withCtx(() => [
                  _hoisted_1,
                  _createTextVNode(" " + _toDisplayString(_ctx.sellerTeam.manager?.email), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, { class: "mt-3" }, {
                default: _withCtx(() => [
                  _hoisted_2,
                  _createTextVNode(" " + _toDisplayString(_ctx.formatterDollars(_ctx.sellerTeam.balance?.amount)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, { class: "mt-3" }, {
                default: _withCtx(() => [
                  _hoisted_3,
                  _createVNode(_component_router_link, { to: {
            path: `/ag/base-cost`,
          } }, {
                    default: _withCtx(({ href }) => [
                      _createVNode(_component_el_link, {
                        href: href,
                        type: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.sellerTeam.basecost?.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["href"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, { class: "mt-3" }, {
                default: _withCtx(() => [
                  _hoisted_5,
                  _createTextVNode(" " + _toDisplayString(_ctx.sellerTeam.supporter?.email), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, { class: "mt-3" }, {
                default: _withCtx(() => [
                  _hoisted_6,
                  _createTextVNode(" " + _toDisplayString(_ctx.sellerTeam.id), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 512), [
            [_directive_loading, _ctx.isLoading]
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}